import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { connect } from 'react-redux';

const HangupPage = ({ phone, dispatch }) => {

  const disconnectSipServer = async () => {
    const { userAgent, registerer } = phone;
    await userAgent.stop();
    dispatch({
      type: 'phone/setFields',
      payload: {
        userAgent: null,
        registerer: null,
      },
    });
  };
  useEffect(() => {
    disconnectSipServer();
  }, []);

  return (
    <div className="flex flex-col justify-start items-stretch">
      <div className="p-3 text-center font-xs">Call Ended. You may close this window.</div>
    </div>
  );
};

export default connect(({
  phone
}) => ({
  phone
}))(HangupPage);
